<template>
  <div id="app">
    <Header titulo="Preventa online"></Header>
    <div class="container">
      <p class="intro-copy" v-if="0">Ahora podés averiguar si tu vehículo está alcanzado a una campaña especial de servicio vigente, ingresando el número de Chasis o Patente</p>
    </div>
    <Form v-if="!loading" ref="formulario"></Form>
    <div class="container" v-else>
      <p>Cargando...</p>
    </div>
  </div>
</template>

<script>
import Header from "./components/Header.vue";
import Form from "./components/Form.vue";

export default {
  name: "app",
  components: {
    Header,
    Form
  },
  data() {
    return {
      loading: true
    };
  },
  mounted: function() {
    // document.title = "Volkswagen Argentina | Recall";
    this.loading = false;
  }
};
</script>

<style lang="scss">
@import "./assets/scss/_fonts.scss";

#app {
  font-family: "vw-head", Arial, Helvetica, sans-serif;
  padding-bottom: 10em;
  padding-top: 7em;
  @media (max-width: 1441px) {
    font-size: 12px;
  }

  #dejanos {
    font-weight: 300;
    font-size: 2.3em;
    letter-spacing: -0.015em;
    padding: 4px;
    &+p {
      color: #001e50;
      font-size: 1.35em;
      padding: 4px;
      text-decoration: underline;
      @media (max-width: 767px) {
        font-size: 1.1em;
        padding: 7px 4.5%;
      }
    }
    @media (max-width: 767px) {
      font-size: 2.1em;
      padding: 0 4.3%;
      margin: 0.7em 0 0;
      letter-spacing: -0.005em;
    }
    span {
      font-weight: 400;
      letter-spacing: -0.004em;
    }
  }

  .intro-copy {
    font-size: 1.35em;
    font-family: "vw-head", Arial, Helvetica, sans-serif;
    margin: 2.5em auto 2.2em;
    letter-spacing: -0.006em;
    padding-left: 5px;
    @media (max-width: 669px) {
      font-size: 1.7em;
      margin: 1em 0;
      letter-spacing: 0;
      padding: 0 5%;
      line-height: 1.75em;
    }
  }

  @media (min-width: 1640px) {
    .container {
      width: 100%;
      max-width: 1640px;
    }
  }
  .vfl-label,
  .vfl-label-on-input,
  .vfl-label-on-focus {
    color: #001e50;
  }
  .select .vfl-label,
  .select .vfl-label-on-input,
  .select .vfl-label-on-focus {
    margin-left: 4px;
  }
  .has-error .vfl-label,
  .has-error .vfl-label-on-input,
  .has-error .vfl-label-on-focus {
    color: #dd2c00;
  }
}
@media(max-width: 767px) {
  .vfl-label-on-input {
    top: -0.7em;
  }
}

.swal2-popup {
  font-size: 1em;
}
#swal2-title {
  line-height: 1.3;
  font-family: "vw-head", Arial, Helvetica, sans-serif;
  font-weight: 200;
}

.swal2-popup .swal2-actions button.swal2-confirm {
  border: none !important;
  border-radius: 22px;
  font-size: 1em;
  padding: 0.5em 2.8em 0.6em;
  letter-spacing: -0.04em;
  color: #fff;
  background: #001e50;
  margin-bottom: 1em;
  font-family: "vw-head", Arial, Helvetica, sans-serif;
  font-weight: 200;
  &:focus,
  &:active {
    box-shadow: none;
    outline: none;
  }
}

#swal2-content a.btn {
  border: 1px solid #001e50;
  border-radius: 22px;
  font-size: 1.2em;
  padding: 0.6em 2.8em;
  letter-spacing: -0.04em;
  color: #001e50;
  background: white;
  margin-bottom: 1em;
  &:focus,
  &:active {
    box-shadow: none;
    outline: none;
  }
}

.swal2-popup #swal2-content {
  font-size: 1.1em;
}

.swal2-container .swal2-modal {
  max-width: 1600px;
  padding: 5em 4.4% 8em;
  @media(max-width: 1441px) {
    max-width: 1200px;
  }
  @media(max-width: 767px) {
    padding: 2em;
  }
}

.swal2-popup .swal2-close:focus {
  border: none;
  box-shadow: none;
  outline: none !important;
}
.azul {
  color: #001e50;
}
.swal2-popup h4 {
  color: #001e50;
  // font-size: 3.1em;
  font-size: 2.2em;
  font-weight: 300;
  letter-spacing: 0.045em;
  margin-bottom: 1.5em;
  @media(max-width: 767px) {
    font-size: 1.7em;
  }
}
.swal2-popup p {
  // font-size: 2.1em;
  font-size: 1.7em;
  margin-bottom: 0;
  margin-top: 0.85em;
  font-weight: 300;
  margin-left: -2px;
  line-height: 1.35em;
  width: 95%;
  margin-bottom: 2em;
  @media(max-width: 767px) {
    font-size: 1.5em;
  }
}
.swal2-popup p strong {
  font-weight: bold;
}

a.azul {
  text-decoration: underline;
}
#revisiones table {
  text-align: left;
  font-size: 1.4em;
  margin-top: 2em;
  max-width: 1100px;
  width: 100%;
}
#revisiones table tr {
  border-bottom: 1px solid #333;
  font-size: 0.9em;
}
#revisiones table th, #revisiones table td {
  padding: 3px 15px;
}
.swal2-popup small {
  font-size: 0.9em;
  text-align: left;
  margin-top: 2em;
  display: block;
  line-height: 1.4em;
  padding: 26px 15px;
}
#tarjeta img {
  width: 97%;
}
@media(min-width: 769px) {
  #tarjeta .col-sm-5 {
    padding: 0;
  }
}
#tarjeta {
  padding-top: 0.6em;
  @media(max-width: 1441px) {
    font-size: 0.85em;
  }
}
#tarjeta h5 {
  padding-top: 0.4em;
  font-size: 1.7em;
  font-weight: 400;
  margin: 0;
  @media(max-width: 767px) {
    padding-top: 1.7em;
  }
}
#tarjeta h6 {
  font-size: 1.25em;
  letter-spacing: -0.01em;
  margin: 1.4em 0 0;
}
#tarjeta ol {
  padding: 0;
  list-style-position: inside;
  margin: 1em 0;
  font-size: 1em;
  font-weight: 400;
  line-height: 1.05em;
  letter-spacing: -0.025em;
  @media(max-width: 1441px) {
    line-height: 1.2em;
  }
}
#tarjeta ol li {
  margin-bottom: 1em;
}
#resultado {
  @media(max-width: 1441px) {
    font-size: 0.65em;
  }
}
#no-tenes {
  max-width: 1000px;
}
.no-pad {
  padding: 0;
  @media(max-width: 767px) {
    text-align: left;
    img {
      max-width: 50px;
      margin: 0 10px;
    }
  }
}
.no-pad+div {
  padding-left: 3.5%;
}
#revisiones {
  padding: 0 6% 0 11.8%;
  @media(max-width: 767px) {
    padding: 0 5%;
  }
}
#revisiones p {
  text-align: left;
  font-size: 1.8em;
  padding-top: 12px;
}
.swal2-container .swal2-modal {
  max-width: 700px !important;
}
</style>